module.exports = __webpack_public_path__ + "img/veri.4f540976.svg";